import $ from 'jquery';
class Mobilemenu {
    constructor() {
        this.hamburgerBtn = $(".hamburger-btn");
        this.closeBtn = $(".close-btn");
        this.mobileMenu = $(".mobile--menu");
        this.menuLinks = $(".mobile--menu li");
        this.popUps = $(".box");
        this.events();
    }
    events() {
        this.hamburgerBtn.on("click", () => {
            this.activateBurger();
        });
        this.closeBtn.on("click", () => {
            this.closeBurger();
        });
        this.menuLinks.on("click", () => {
            this.closeBurger();
        });
    }
    activateBurger() {
        this.hamburgerBtn.css("display", "none");
        this.closeBtn.css("display", "block");
        this.mobileMenu.addClass("showMenu");
        //this.popUps.css("z-index", "-1");
        $("body").css("overflow", "hidden");
    }
    closeBurger() {
        this.closeBtn.css("display", "none");
        this.hamburgerBtn.css("display", "block");
        this.mobileMenu.removeClass("showMenu");
        //this.popUps.css("z-index", "0");
        $("body").css("overflow", "visible");
    }
}
export default Mobilemenu;